import { Field } from 'Util/Query';

/** @namespace Query/Banners */

export class BannersQuery {

    getQuery(path = "/") {
        return new Field('banners')
            .addArgument('url', 'String!', path)
            .addFieldList([this._getBannersField()]);
    }

    _getBannersField() {
        return new Field('banners')
            .addFieldList(this._getBannersFieldItems());
    }

    _getBannersFieldItems() {
        return [
            'banner',
            'popup'
        ];

    }
}

export default new BannersQuery();
